export default class Ads {

    static initializeEvents() {
        fetch('https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js')
            .then(response => {
                if (!response.ok) {
                    this.removeAdPlaceholders();
                }
            })
            .catch(this.removeAdPlaceholders);
    }

    static removeAdPlaceholders() {
        Array
            .from(document.querySelectorAll('[data-cls-placeholder]'))
            .forEach(placeholder => placeholder.parentNode.removeChild(placeholder));
    }

}